export default "__VITE_ASSET__DacP10SU__"